import { useEffect, useMemo, useState } from 'react'
import { useAuth } from './useAuth'
import {
  MOBILE_PROFILES,
  getMobileAppProfile,
  canAccessDefectSheetsMobile,
  canAccessQuotationsMobile,
  canEditDefectSheetsMobile,
} from '../utils/mobileProfile'
import {
  MOBILE_WEB_MAX_WIDTH,
  appliesMobileProfile,
  getMobileWebDefaultRoute,
  isPathAllowedOnMobileWeb,
  getMobileWebRoleLabel,
} from '../utils/mobileWebAccess'

export function useMobileWebProfile() {
  const { user } = useAuth()
  const [isMobileWeb, setIsMobileWeb] = useState(() => {
    if (typeof window === 'undefined') return false
    return window.matchMedia(`(max-width: ${MOBILE_WEB_MAX_WIDTH}px)`).matches
  })

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_WEB_MAX_WIDTH}px)`)
    const onChange = () => setIsMobileWeb(mq.matches)
    onChange()
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [])

  const applies = appliesMobileProfile(user, isMobileWeb)
  const profile = getMobileAppProfile(user)

  return useMemo(
    () => ({
      isMobileWeb,
      appliesMobileProfile: applies,
      profile,
      defaultRoute: user ? getMobileWebDefaultRoute(user) : '/dashboard',
      roleLabel: user ? getMobileWebRoleLabel(user) : '',
      isPathAllowed: (pathname) =>
        user ? isPathAllowedOnMobileWeb(user, pathname) : true,
      isSalesProfile: applies && profile === MOBILE_PROFILES.SALES,
      isWebOnlyProfile: applies && profile === MOBILE_PROFILES.NONE,
      quotationsReadOnly: applies && profile === MOBILE_PROFILES.SALES,
      defectSheetsReadOnly: applies && !canEditDefectSheetsMobile(user),
      canAccessQuotations: canAccessQuotationsMobile(user),
      canAccessDefectSheets: canAccessDefectSheetsMobile(user),
    }),
    [isMobileWeb, applies, profile, user]
  )
}
